import type { Member } from '@rp/contracts'
import { Button, Dialog } from '../../design'
import { SETTINGS_COPY } from './copy'

type MemberRemoveDialogProps = {
  member: Member | null
  workspace: string
  selfId: string
  pending: boolean
  onCancel: () => void
  onConfirm: (member: Member) => void
}

export const MemberRemoveDialog = ({ member, workspace, selfId, pending, onCancel, onConfirm }: MemberRemoveDialogProps) => (
  <Dialog
    open={member !== null}
    title={SETTINGS_COPY.removeTitle}
    onClose={onCancel}
    tone="danger"
    edge="hatch"
    footer={
      <>
        <Button onClick={onCancel}>{SETTINGS_COPY.cancel}</Button>
        <Button
          variant="danger-solid"
          pending={pending}
          pendingLabel={SETTINGS_COPY.removing}
          onClick={() => (member === null ? undefined : onConfirm(member))}
        >
          {SETTINGS_COPY.confirmRemove}
        </Button>
      </>
    }
  >
    {member === null ? null : (
      <>
        <p className="measure">{SETTINGS_COPY.removeBody(member.email, workspace)}</p>
        {member.userId === selfId ? (
          <p className="measure text-tone tone-danger">{SETTINGS_COPY.removeSelfNote}</p>
        ) : null}
      </>
    )}
  </Dialog>
)
